import "./Results.css";

import React, {memo, useState} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChevronDown, faChevronUp} from '@fortawesome/free-solid-svg-icons';

import {PhraseSet} from "features/validationRules/types";

const PhraseSetComponent = ({docsAmount, idx, phraseSet: {common_for, phrases}}: { docsAmount: number, phraseSet: PhraseSet, idx: number }) => {
    const [extended, setExtended] = useState<boolean>(false);

    return (
        <div className={"res-wrapper"}>
            <div className="res-container" onClick={() => {setExtended(!extended)}}>
                <p className="res-name">Phrase Set #{idx + 1}{extended? " ("+phrases.length+" phrase"+(phrases.length === 1? "" : "s")+")" :" (common for "+common_for.length+"/"+docsAmount+" docs)"}</p>
                <div className="chevron-wrapper">
                    <FontAwesomeIcon icon={extended? faChevronUp : faChevronDown}/>
                </div>
            </div>
            <div className="extendable-res-container" style={{display: extended? "flex" : "none"}}>
                <ExtendableLinksComponent docsAmount={docsAmount} documents={common_for}/>
                {phrases.map((phrase, idx) => <p key={`${idx}-${phrase.substring(0, 20)}`} className="extendable-res-container-content">{phrase}</p>)}
            </div>
        </div>
    );
}

const ExtendableLinksComponent = ({docsAmount, documents}: { docsAmount: number, documents: string[] }) => {
    const [extended, setExtended] = useState<boolean>(false);
    return (
        <div className="links-wrapper">
            <div className="links-container" onClick={() => {
                setExtended(!extended)
            }}>
                <p className="res-name">Common for {documents.length}/{docsAmount} docs{extended ? ":" : ""}</p>
                <div className="chevron-wrapper">
                    <FontAwesomeIcon icon={extended ? faChevronUp : faChevronDown}/>
                </div>
            </div>
            <div className="extendable-res-container" style={{display: extended ? "flex" : "none"}}>
                {extended ? documents.map(link => <a key={link} className="extendable-res-container-content" target="_blank" rel="noreferrer" href={link}>{link.split('&')[1].split('=')[1]}</a>) : <></>}
            </div>
            
        </div>
    );
}

export default memo(PhraseSetComponent);